import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import {
  Description1f0zycfwk0zld as Description,
  MaxLength2eo8ysfurfau1 as MaxLength,
  Multilinevduzy7shc6h7 as Multiline,
  AdminTitleFields1r7jr8w0z0gjc as AdminTitleFields,
  AdminTableColumns127mx0x3shj3w as AdminTableColumns,
} from '../../../../service-abstractions-data-shared/com/lightningkite/services/data/Annotations.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  ServerFile2veqsg2df5jtr as ServerFile,
  ServerFile__hashCode_impl_qj0ii51v31c23ib9tv8 as ServerFile__hashCode_impl_qj0ii5,
} from '../../../../service-abstractions-files-client/com/lightningkite/services/files/ServerFile.mjs';
import { DeferToContextualServerFileSerializer_getInstancebet21aefs4ur as DeferToContextualServerFileSerializer_getInstance } from '../../../../service-abstractions-files-client/com/lightningkite/services/files/DirectServerFileSerializer.mjs';
import {
  $serializer_getInstance36a6xm1fkegaj as $serializer_getInstance,
  ContactInfo1q5ur6ox19zr5 as ContactInfo,
} from './types.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { StringSerializer_getInstance1p9zda6r6kb23 as StringSerializer_getInstance } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  equals2au1ep9vhcato as equals,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { HasId24qpfucecockd as HasId } from '../../../../service-abstractions-database-shared/com/lightningkite/services/database/HasId.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.MAIN_1 = 'main';
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_0();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.DynamicSettings', this, 8);
        tmp0_serialDesc.addElement_5pzumi_k$('_id', true);
        tmp0_serialDesc.addElement_5pzumi_k$('placementAgreementTemplate', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Description())('The blank placement agreement, as a fillable PDF. Its form field names decide both what data is stamped on and who has to sign; download the field reference for the list.'));
        tmp0_serialDesc.addElement_5pzumi_k$('placementAgreementSubject', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Description())('Subject line of the signing request email.'));
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (MaxLength())(100));
        tmp0_serialDesc.addElement_5pzumi_k$('placementAgreementMessage', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Description())('Message shown to signers in the signing request email.'));
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Multiline())());
        tmp0_serialDesc.addElement_5pzumi_k$('employerAgreementTemplate', true);
        tmp0_serialDesc.addElement_5pzumi_k$('employerAgreementSubject', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (MaxLength())(100));
        tmp0_serialDesc.addElement_5pzumi_k$('employerAgreementMessage', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Multiline())());
        tmp0_serialDesc.addElement_5pzumi_k$('tcgSigner', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Description())("Who signs on TCG's behalf. A template asks for this signature as `Signature.tcg.email`."));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTitleFields())(['_id']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTableColumns())(['_id']));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_smofx7_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !(value._id_1 === 'main')) {
          tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 0, value._id_1);
        }
        var tmp;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1)) {
          tmp = true;
        } else {
          var tmp_0 = value.placementAgreementTemplate_1;
          tmp = !((tmp_0 == null ? null : new (ServerFile())(tmp_0)) == null);
        }
        if (tmp) {
          var tmp_1 = DeferToContextualServerFileSerializer_getInstance();
          var tmp_2 = value.placementAgreementTemplate_1;
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 1, tmp_1, tmp_2 == null ? null : new (ServerFile())(tmp_2));
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2) ? true : !(value.placementAgreementSubject_1 === 'Child placement agreement')) {
          tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 2, value.placementAgreementSubject_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 3) ? true : !(value.placementAgreementMessage_1 === '')) {
          tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 3, value.placementAgreementMessage_1);
        }
        var tmp_3;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 4)) {
          tmp_3 = true;
        } else {
          var tmp_4 = value.employerAgreementTemplate_1;
          tmp_3 = !((tmp_4 == null ? null : new (ServerFile())(tmp_4)) == null);
        }
        if (tmp_3) {
          var tmp_5 = DeferToContextualServerFileSerializer_getInstance();
          var tmp_6 = value.employerAgreementTemplate_1;
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 4, tmp_5, tmp_6 == null ? null : new (ServerFile())(tmp_6));
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 5) ? true : !(value.employerAgreementSubject_1 === 'Employer Agreement')) {
          tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 5, value.employerAgreementSubject_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 6) ? true : !(value.employerAgreementMessage_1 === '')) {
          tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 6, value.employerAgreementMessage_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 7) ? true : !value.tcgSigner_1.equals(new (ContactInfo())())) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 7, $serializer_getInstance(), value.tcgSigner_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_smofx7_k$(encoder, value instanceof DynamicSettings() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp12_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp12_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          var tmp = DeferToContextualServerFileSerializer_getInstance();
          var tmp_0 = tmp5_local1;
          var tmp_1 = tmp12_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, tmp, tmp_0 == null ? null : new (ServerFile())(tmp_0));
          tmp5_local1 = tmp_1 == null ? null : tmp_1.location_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp12_input.decodeStringElement_3oenpg_k$(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp12_input.decodeStringElement_3oenpg_k$(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          var tmp_2 = DeferToContextualServerFileSerializer_getInstance();
          var tmp_3 = tmp8_local4;
          var tmp_4 = tmp12_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 4, tmp_2, tmp_3 == null ? null : new (ServerFile())(tmp_3));
          tmp8_local4 = tmp_4 == null ? null : tmp_4.location_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp12_input.decodeStringElement_3oenpg_k$(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp12_input.decodeStringElement_3oenpg_k$(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp12_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 7, $serializer_getInstance(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp12_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp12_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                var tmp_5 = DeferToContextualServerFileSerializer_getInstance();
                var tmp_6 = tmp5_local1;
                var tmp_7 = tmp12_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, tmp_5, tmp_6 == null ? null : new (ServerFile())(tmp_6));
                tmp5_local1 = tmp_7 == null ? null : tmp_7.location_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp12_input.decodeStringElement_3oenpg_k$(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp12_input.decodeStringElement_3oenpg_k$(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                var tmp_8 = DeferToContextualServerFileSerializer_getInstance();
                var tmp_9 = tmp8_local4;
                var tmp_10 = tmp12_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 4, tmp_8, tmp_9 == null ? null : new (ServerFile())(tmp_9));
                tmp8_local4 = tmp_10 == null ? null : tmp_10.location_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp12_input.decodeStringElement_3oenpg_k$(tmp0_desc, 5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp12_input.decodeStringElement_3oenpg_k$(tmp0_desc, 6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp12_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 7, $serializer_getInstance(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp12_input.endStructure_1xqz0n_k$(tmp0_desc);
        return DynamicSettings().new_org_thecommunitygroupinc_cares_DynamicSettings_i4onm2_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), get_nullable(DeferToContextualServerFileSerializer_getInstance()), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(DeferToContextualServerFileSerializer_getInstance()), StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance_0() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var DynamicSettingsClass;
function DynamicSettings() {
  if (DynamicSettingsClass === VOID) {
    class $ {
      constructor(_id, placementAgreementTemplate, placementAgreementSubject, placementAgreementMessage, employerAgreementTemplate, employerAgreementSubject, employerAgreementMessage, tcgSigner) {
        _id = _id === VOID ? 'main' : _id;
        placementAgreementTemplate = placementAgreementTemplate === VOID ? null : placementAgreementTemplate;
        placementAgreementSubject = placementAgreementSubject === VOID ? 'Child placement agreement' : placementAgreementSubject;
        placementAgreementMessage = placementAgreementMessage === VOID ? '' : placementAgreementMessage;
        employerAgreementTemplate = employerAgreementTemplate === VOID ? null : employerAgreementTemplate;
        employerAgreementSubject = employerAgreementSubject === VOID ? 'Employer Agreement' : employerAgreementSubject;
        employerAgreementMessage = employerAgreementMessage === VOID ? '' : employerAgreementMessage;
        tcgSigner = tcgSigner === VOID ? new (ContactInfo())() : tcgSigner;
        this._id_1 = _id;
        this.placementAgreementTemplate_1 = placementAgreementTemplate;
        this.placementAgreementSubject_1 = placementAgreementSubject;
        this.placementAgreementMessage_1 = placementAgreementMessage;
        this.employerAgreementTemplate_1 = employerAgreementTemplate;
        this.employerAgreementSubject_1 = employerAgreementSubject;
        this.employerAgreementMessage_1 = employerAgreementMessage;
        this.tcgSigner_1 = tcgSigner;
      }
      get__id_18jb1r_k$() {
        return this._id_1;
      }
      toString() {
        var tmp = this.placementAgreementTemplate_1;
        var tmp_0 = toString(tmp == null ? null : new (ServerFile())(tmp));
        var tmp_1 = this.employerAgreementTemplate_1;
        return 'DynamicSettings(_id=' + this._id_1 + ', placementAgreementTemplate=' + tmp_0 + ', placementAgreementSubject=' + this.placementAgreementSubject_1 + ', placementAgreementMessage=' + this.placementAgreementMessage_1 + ', employerAgreementTemplate=' + toString(tmp_1 == null ? null : new (ServerFile())(tmp_1)) + ', employerAgreementSubject=' + this.employerAgreementSubject_1 + ', employerAgreementMessage=' + this.employerAgreementMessage_1 + ', tcgSigner=' + this.tcgSigner_1.toString() + ')';
      }
      hashCode() {
        var result = getStringHashCode(this._id_1);
        var tmp = imul(result, 31);
        var tmp_0;
        var tmp_1 = this.placementAgreementTemplate_1;
        if ((tmp_1 == null ? null : new (ServerFile())(tmp_1)) == null) {
          tmp_0 = 0;
        } else {
          tmp_0 = ServerFile__hashCode_impl_qj0ii5(this.placementAgreementTemplate_1);
        }
        result = tmp + tmp_0 | 0;
        result = imul(result, 31) + getStringHashCode(this.placementAgreementSubject_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.placementAgreementMessage_1) | 0;
        var tmp_2 = imul(result, 31);
        var tmp_3;
        var tmp_4 = this.employerAgreementTemplate_1;
        if ((tmp_4 == null ? null : new (ServerFile())(tmp_4)) == null) {
          tmp_3 = 0;
        } else {
          tmp_3 = ServerFile__hashCode_impl_qj0ii5(this.employerAgreementTemplate_1);
        }
        result = tmp_2 + tmp_3 | 0;
        result = imul(result, 31) + getStringHashCode(this.employerAgreementSubject_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.employerAgreementMessage_1) | 0;
        result = imul(result, 31) + this.tcgSigner_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DynamicSettings()))
          return false;
        if (!(this._id_1 === other._id_1))
          return false;
        var tmp = this.placementAgreementTemplate_1;
        var tmp_0 = tmp == null ? null : new (ServerFile())(tmp);
        var tmp_1 = other.placementAgreementTemplate_1;
        if (!equals(tmp_0, tmp_1 == null ? null : new (ServerFile())(tmp_1)))
          return false;
        if (!(this.placementAgreementSubject_1 === other.placementAgreementSubject_1))
          return false;
        if (!(this.placementAgreementMessage_1 === other.placementAgreementMessage_1))
          return false;
        var tmp_2 = this.employerAgreementTemplate_1;
        var tmp_3 = tmp_2 == null ? null : new (ServerFile())(tmp_2);
        var tmp_4 = other.employerAgreementTemplate_1;
        if (!equals(tmp_3, tmp_4 == null ? null : new (ServerFile())(tmp_4)))
          return false;
        if (!(this.employerAgreementSubject_1 === other.employerAgreementSubject_1))
          return false;
        if (!(this.employerAgreementMessage_1 === other.employerAgreementMessage_1))
          return false;
        if (!this.tcgSigner_1.equals(other.tcgSigner_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_DynamicSettings_i4onm2_k$(seen0, _id, placementAgreementTemplate, placementAgreementSubject, placementAgreementMessage, employerAgreementTemplate, employerAgreementSubject, employerAgreementMessage, tcgSigner, serializationConstructorMarker) {
        if (!(0 === (0 & seen0))) {
          throwMissingFieldException(seen0, 0, $serializer_getInstance_0().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this._id_1 = 'main';
        else
          $this._id_1 = _id;
        if (0 === (seen0 & 2))
          $this.placementAgreementTemplate_1 = null;
        else
          $this.placementAgreementTemplate_1 = placementAgreementTemplate;
        if (0 === (seen0 & 4))
          $this.placementAgreementSubject_1 = 'Child placement agreement';
        else
          $this.placementAgreementSubject_1 = placementAgreementSubject;
        if (0 === (seen0 & 8))
          $this.placementAgreementMessage_1 = '';
        else
          $this.placementAgreementMessage_1 = placementAgreementMessage;
        if (0 === (seen0 & 16))
          $this.employerAgreementTemplate_1 = null;
        else
          $this.employerAgreementTemplate_1 = employerAgreementTemplate;
        if (0 === (seen0 & 32))
          $this.employerAgreementSubject_1 = 'Employer Agreement';
        else
          $this.employerAgreementSubject_1 = employerAgreementSubject;
        if (0 === (seen0 & 64))
          $this.employerAgreementMessage_1 = '';
        else
          $this.employerAgreementMessage_1 = employerAgreementMessage;
        if (0 === (seen0 & 128))
          $this.tcgSigner_1 = new (ContactInfo())();
        else
          $this.tcgSigner_1 = tcgSigner;
        return $this;
      }
    }
    initMetadataForClass($, 'DynamicSettings', DynamicSettings, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_0});
    DynamicSettingsClass = $;
  }
  return DynamicSettingsClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Companion_instance as Companion_instance1tjb9nvha71oi,
  DynamicSettings as DynamicSettingsasnz4qmzwqci,
};
//endregion

//# sourceMappingURL=dynamicSettings.mjs.map
